<script setup>
import { useDisplay } from "vuetify";
import { INSTRUCTION_TEXTS } from "@/utils/constant";
import LeaderboardComponent from "@/components/Game/Leaderboard.vue";

definePage({
  name: "RanksMobileLeaderboard",
  path: "/ranks/mobile-leaderboard",
  meta: {
    layout: "default",
    requiresAuth: true,
    title: "Leaderboard",
    description: "Check Nexus leaderboards and rankings.",
  },
});

const authStore = useAuthStore();
const router = useRouter();
const { mobile } = useDisplay();
const onboarding = useOnboardingStore();

// Redirect to desktop version on desktop devices
onMounted(() => {
  if (!mobile.value) {
    router.replace("/ranks");
  }

  if (!onboarding.shown.rank) {
    onboarding.showInstruction({
      text: INSTRUCTION_TEXTS.rank,
      onClose: () => onboarding.markShown("rank"),
    });
  }
});
</script>

<template>
  <!-- StarrySky as fixed background -->
  <StarrySky class="" />

  <!-- Main Content -->
  <div class="tw-page-container tw-min-h-screen tw-relative">
    <v-container>
      <div
        class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 xl:tw-grid-cols-[9fr_11fr] tw-gap-4"
      >
        <v-sheet color="transparent" class="tw-pt-7">
          <LeaderboardComponent class="tw-mb-4" />
        </v-sheet>
      </div>
    </v-container>
  </div>
</template>

<style>
/* Mobile specific styles */
.tw-mobile-page-content {
  padding: 16px 0;
}

/* Ensure content is visible above the starfield */
.tw-page-container {
  background-color: transparent;
}
</style>
